<template>
    <st-float-styled :float="float" :block="block">
        <slot />
    </st-float-styled>
</template>
<script>
import styled from "vue-styled-components";

const props = {
    float: String,
    block: Boolean
};

const StFloatStyled = styled("div", props)`
    display: inline-block;
    float: ${props => props.float || "left"};
    ${props => props.block && "width: 100%;"}
`;

export default {
    name: "StFloat",
    props: {
        ...props
    },
    methods: {},
    components: {
        StFloatStyled
    }
};
</script>
